import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {initiativeModelReport_template} from "../components/templates/initiativeModelReport_template";

declare var ko: any;
declare var page: any;

export class initiativeModelReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlListData: XMLHttpRequestHandler;
    protected XHRHdlCostAllocationData: XMLHttpRequestHandler;
    protected initiativeModelReportTemplate: initiativeModelReport_template;

    protected getModuleName(){

        return "initiativeModelReport";
    }

    buildContent() : Array<Element>{

        // create the goals list
        this.initiativeModelReportTemplate = new initiativeModelReport_template("initiativeModelReport", this.viewModel, this);

        return [this.initiativeModelReportTemplate.build()];
    }

    public fillPage() : void{

        this.initiativeModelReportTemplate.buildDatePickerCalendar();
        this.getListFormData();
    }

    public reportDataReorder(): void {
        this.getListData();
    }


    protected getListFormData(): void {

        this.loadingIn(this.initiativeModelReportTemplate.builtTemplate.children.namedItem("sub-filters"));

        let subViewModel = this.initiativeModelReportTemplate.getViewModelForRequest();

        let usrReq_url: string = '/api/initiative_model_report/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getListData();
                }
            });
        }
    }

    protected updateFilters(responseParsed: any): void {
        this.initiativeModelReportTemplate.resetSubFilters();
        this.initiativeModelReportTemplate.setBrandsFilterItems(responseParsed.brands);
        this.initiativeModelReportTemplate.setInitiativesFilterItems(responseParsed.initiatives);
        this.initiativeModelReportTemplate.setGroupsFilterItems(responseParsed.groups);

        this.loadingOut(this.initiativeModelReportTemplate.builtTemplate.children.namedItem("sub-filters"));
    }

    public getListData(): void {

        this.loadingIn(this.initiativeModelReportTemplate.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdlListData ){

            this.XHRHdlListData.cancelAndReset();
        }

        let subViewModel = this.initiativeModelReportTemplate.getViewModelForRequest();

        let usrReq_url: string = '/api/initiative_model_report/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlListData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlListData.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdlListData.execute();

    }

    /**
     * @param req
     * @param obj
     * @protected
     */
    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.updateList(response);

                obj.loadingOut(obj.initiativeModelReportTemplate.builtTemplate.children.namedItem("list-results"));
            });
        }
    }


    //
    // update the module list using the objects list
    protected updateList(report: any){

        this.initiativeModelReportTemplate.setReportData(report);
    }







    public getCostAllocationData(month, year): void {

        if( this.XHRHdlCostAllocationData ){

            this.XHRHdlCostAllocationData.cancelAndReset();
        }

        let subViewModel = this.initiativeModelReportTemplate.getViewModelForRequest();
        subViewModel['targetMonth'] = month;
        subViewModel['targetYear'] = year;

        let usrReq_url: string = '/api/initiative_model_report/cost_allocations/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdlCostAllocationData = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdlCostAllocationData.onReadyStateFunction = this.onCostAllocationRequestReturn;
        this.XHRHdlCostAllocationData.execute();

    }

    /**
     * @param req
     * @param obj
     * @protected
     */
    protected onCostAllocationRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.initiativeModelReportTemplate.getTemplateViewModel().costAllocations(response);

                obj.loadingOut(obj.initiativeModelReportTemplate.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    public filterSimpleCancel(): void {
        console.log('filterSimpleCancel');
    }

    public onChangeFilterAction():void {
        console.log('onChangeFilterAction');
    }

    protected filterSingleDateOnChange(): void {

        this.getListFormData();
    }

    protected filterDropdownOnChange() {

        this.getListFormData();
    }

    protected filterDateOnChange(): void {

        this.getListFormData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/initiativeModelReport.ts